(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-thunder-axe-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var modal = document.querySelector('[data-ta-video-modal]');
  if (!modal) return;

  var frameHost = modal.querySelector('[data-ta-video-frame]');
  var loadingEl = modal.querySelector('[data-ta-modal-loading]');
  var unmuteBtn = modal.querySelector('[data-ta-unmute-btn]');
  var tapPlayBtn = modal.querySelector('[data-ta-tap-play-btn]');
  var closeEls = modal.querySelectorAll('[data-ta-video-close]');
  var triggers = document.querySelectorAll('[data-ta-video-trigger]');
  var lastFocused = null;
  var currentPlayer = null;
  var playbackConfirmed = false;
  var fallbackTimer = null;
  var sdkPollTimer = null;

  // Cloudflare Stream customer subdomain (account-wide, same for every video).
  var cfCustomerCode = 'customer-tqj8mzg0aeggvtml';

  // Preload the Cloudflare Stream Player SDK once, ahead of any click, purely
  // as a best-effort helper for auto-unmuting. Playback itself never waits
  // on this — on slow mobile connections the script can take a while (or
  // fail), and gating playback on it is what left videos not playing at all.
  var streamSdkReady = false;
  (function preloadStreamSdk() {
    if (window.Stream) {
      streamSdkReady = true;
      return;
    }
    var script = document.createElement('script');
    script.src = 'https://embed.cloudflarestream.com/embed/sdk.latest.js';
    script.onload = function () {
      streamSdkReady = true;
    };
    document.head.appendChild(script);
  })();

  function openModal(cfVideoId, title, spinnerEl) {
    if (!cfVideoId) return;

    if (spinnerEl) spinnerEl.classList.add('is-active');
    if (unmuteBtn) unmuteBtn.hidden = true;
    if (tapPlayBtn) tapPlayBtn.hidden = true;
    currentPlayer = null;
    playbackConfirmed = false;
    if (fallbackTimer) clearTimeout(fallbackTimer);
    if (sdkPollTimer) clearInterval(sdkPollTimer);

    // Make the modal visible FIRST, before the iframe is created. Mobile
    // browsers (Safari in particular) refuse to autoplay video that isn't
    // actually part of the rendered layout yet — appending the iframe while
    // the modal was still `display: none` (0x0 size) is why autoplay was
    // silently failing after the spinner.
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    lastFocused = document.activeElement;
    if (loadingEl) loadingEl.classList.remove('is-hidden');

    // Always request muted autoplay via the URL itself — this is allowed by
    // every mobile and desktop browser with no gesture requirements, so the
    // video is guaranteed to actually start. Sound is layered on top of
    // this, never a precondition for playback.
    var iframe = document.createElement('iframe');
    iframe.src =
      'https://' + cfCustomerCode + '.cloudflarestream.com/' +
      encodeURIComponent(cfVideoId) +
      // controls=false hides Cloudflare's own native play button, so only
      // our custom loading spinner / tap-to-play button is ever shown —
      // otherwise the two overlap and look like two play buttons at once.
      '/iframe?autoplay=true&muted=true&preload=auto&controls=false&letterboxColor=%23000000';
    iframe.title = title || 'Video';
    iframe.allow =
      'accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.addEventListener('load', function () {
      if (spinnerEl) spinnerEl.classList.remove('is-active');
      if (loadingEl) loadingEl.classList.add('is-hidden');
    });

    frameHost.innerHTML = '';
    frameHost.appendChild(iframe);

    closeEls[0].focus();

    // Watch for genuine playback starting (via the SDK's "playing" event).
    // If the SDK isn't ready yet, poll briefly for it rather than waiting
    // indefinitely — this never blocks the muted-autoplay attempt above.
    var bindPlayingWatcher = function () {
      if (!window.Stream) return false;
      try {
        var player = window.Stream(iframe);
        currentPlayer = player;
        player.addEventListener('playing', function () {
          playbackConfirmed = true;
          if (tapPlayBtn) tapPlayBtn.hidden = true;
          if (loadingEl) loadingEl.classList.add('is-hidden');
        });

        // Best-effort unmuted attempt — carries the click gesture if the
        // SDK was already loaded before this click happened.
        player.muted = false;
        player.volume = 1;
        var unmutedPlay = player.play();
        if (unmutedPlay && typeof unmutedPlay.catch === 'function') {
          unmutedPlay.catch(function () {
            // Sound was refused, but muted playback via the URL param
            // should already be running — just offer the manual tap.
            if (unmuteBtn) unmuteBtn.hidden = false;
          });
        }
        return true;
      } catch (e) {
        return false;
      }
    };

    if (!bindPlayingWatcher()) {
      var pollCount = 0;
      sdkPollTimer = setInterval(function () {
        pollCount++;
        if (bindPlayingWatcher() || pollCount > 20) {
          clearInterval(sdkPollTimer);
        }
      }, 100);
    }

    // Safety net: whatever the cause (Low Power Mode, a strict in-app
    // browser, a slow network) — if nothing confirms playback within 1.8s,
    // stop waiting and show a visible "Tap to Play" button so the video is
    // never just silently stuck.
    fallbackTimer = setTimeout(function () {
      if (!playbackConfirmed) {
        if (loadingEl) loadingEl.classList.add('is-hidden');
        if (spinnerEl) spinnerEl.classList.remove('is-active');
        if (tapPlayBtn) tapPlayBtn.hidden = false;
      }
    }, 1800);
  }

  if (tapPlayBtn) {
    tapPlayBtn.addEventListener('click', function () {
      // A direct tap here is a fresh, unambiguous user gesture — this is
      // what actually plays the video when autoplay was refused outright
      // (e.g. iOS Low Power Mode blocks autoplay entirely, muted or not).
      var iframe = frameHost.querySelector('iframe');
      if (!iframe) return;
      if (!currentPlayer && window.Stream) {
        currentPlayer = window.Stream(iframe);
      }
      if (currentPlayer) {
        currentPlayer.muted = false;
        currentPlayer.volume = 1;
        currentPlayer.play();
      }
      tapPlayBtn.hidden = true;
    });
  }

  if (unmuteBtn) {
    unmuteBtn.addEventListener('click', function () {
      // A direct tap on this button is always a fresh, genuine user
      // gesture, so unmuting here works even when the earlier automatic
      // attempt couldn't.
      var iframe = frameHost.querySelector('iframe');
      if (!iframe) return;
      if (!currentPlayer && window.Stream) {
        currentPlayer = window.Stream(iframe);
      }
      if (currentPlayer) {
        currentPlayer.muted = false;
        currentPlayer.volume = 1;
        currentPlayer.play();
      }
      unmuteBtn.hidden = true;
    });
  }

  function closeModal() {
    modal.hidden = true;
    // Removing the iframe stops playback immediately.
    frameHost.innerHTML = '';
    if (loadingEl) loadingEl.classList.remove('is-hidden');
    if (unmuteBtn) unmuteBtn.hidden = true;
    currentPlayer = null;
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  triggers.forEach(function (trigger) {
    var spinnerEl = trigger.querySelector('[data-ta-spinner]');
    trigger.addEventListener('click', function () {
      openModal(
        trigger.getAttribute('data-cf-video-id'),
        trigger.getAttribute('data-video-title'),
        spinnerEl
      );
    });
  });

  closeEls.forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (!modal.hidden && e.key === 'Escape') {
      closeModal();
    }
  });

  // Sync mobile position dots with the swipeable track.
  var track = document.querySelector('.ta-testimonials__track');
  var dots = document.querySelectorAll('[data-ta-dot]');
  if (track && dots.length) {
    var updateDots = function () {
      var index = Math.round(track.scrollLeft / track.clientWidth) || 0;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    };
    track.addEventListener('scroll', updateDots, { passive: true });
    window.addEventListener('resize', updateDots);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
